export const initialState = () => ({
  openDrawer: true,
  showNavbar: true,
  topBanner: {
    show: false,
    title: "Modo de contingência",
    description:
      "Estamos em modo de contingência, essa venda poderá sofrer alteração, pois não foi possível realizar análise de crédito deste cliente",
    type: "warn"
  },
  loadingScreen: {
    show: false,
    description: ""
  },
  announcement: {
    show: false,
    data: null
  }
})
